import { render, staticRenderFns } from "./wechat.vue?vue&type=template&id=ddaec34a"
import script from "./wechat.vue?vue&type=script&lang=js"
export * from "./wechat.vue?vue&type=script&lang=js"
import style0 from "./wechat.vue?vue&type=style&index=0&id=ddaec34a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports